import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { detectBody } from "../../shared/helpers";

//init

//set jquery global
import * as $ from 'jquery';
window['jQuery'] = $;
window['$'] = $;

//import libs
import 'jquery-slimscroll';

@Component({
    selector: 'dashboard-view',
    templateUrl: './dashboard.view.html',
    styleUrls: ['./dashboard.view.css'],
    encapsulation: ViewEncapsulation.None,    
    host: {
        '(window:resize)': 'onResize()'
    }
})
export class DashboardView implements OnInit {

    constructor(private router: Router) {

        var test: boolean = true;

        if (test = false) {
            this.router.navigate(['login'])
        }
    }

    
    public ngOnInit(): any {
        detectBody();
    }

    public onResize() {
        detectBody();
    }

    SearchItemSelected() {
        
    }

}
